Auth = require 'app/scripts/db/auth'
Controller = require 'app/scripts/controller'
SidebarState = require 'app/scripts/view-models/sidebar-state'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
{ track } = require '@trello/analytics'
t = require('app/scripts/views/internal/teacup-with-helpers')('board_list_item')

template = t.renderable ({ isLoggedIn, name, orgname, url, current, recent, backgroundImageThumbnail, backgroundColor, backgroundBrightness, backgroundTile }) ->
  t.div '.compact-board-tile-wrapper', ->
    styles = {}
    if backgroundImageThumbnail
      styles['background-image'] = t.urlify(backgroundImageThumbnail)
    if backgroundColor
      styles['background-color'] = backgroundColor

    t.span class: t.classify('mod-tiled': backgroundTile, 'compact-board-tile-background': true), style: t.stylify(styles)

    t.span '.compact-board-tile-fade'

    classes =
      'js-open-board': true
      current: current
      'compact-board-tile-link': true
    if backgroundBrightness
      classes[backgroundBrightness] = true

    t.a { class: t.classify(classes), href: url }, ->

      t.span '.compact-board-tile-link-thumbnail', style: t.stylify(styles)

      t.span { class: t.classify('compact-board-tile-link-text': true, details: true, 'has-sub-name': orgname) }, ->

        t.span '.compact-board-tile-link-text-name', { title: name }, ->
          t.text name
        if orgname
          t.span '.compact-board-tile-link-text-sub-name', { title: orgname }, ->
            t.text orgname

      if isLoggedIn
        t.span { class: 'compact-board-tile-link-options' }, ->
          t.span '.compact-board-tile-link-options-unread.js-unread', { title: t.l('there-is-new-activity-on-this-board') }
          if recent
            t.icon 'close', { class: 'js-remove-board compact-board-tile-link-options-remove', title: t.l('click-to-remove-this-board-from-your-recent-boards') }
          t.icon 'star', { class: 'compact-board-tile-link-options-star js-star-board', title: t.l('click-to-star-this-board-it-will-show-up-at-top-of-your-boards-list') }

module.exports = class BoardListSearchItemView extends View
  tagName: 'li'
  className: 'compact-board-tile'

  initialize: ->
    @listenTo @model, 'change:prefs change:name change:idOrganization',
      @frameDebounce @render
    @listenTo Auth.me().boardStarList, 'add remove reset',
      @frameDebounce @renderStarred

    @listenTo @model, 'change:dateLastActivity change:dateLastView',
      @frameDebounce @renderUnread

    if @options?.showOrgName
      @listenTo @model, 'change:idOrganization', =>
        oldOrganization = @modelCache.get('Organization', @model.previous('idOrganization'))
        if oldOrganization?
          @stopListening(oldOrganization, 'change:displayName')

        @listenToOrgNameChange()
        @render()

      @listenToOrgNameChange()

  listenToOrgNameChange: ->
    if @model.getOrganization()?
      @listenTo @model.getOrganization(), 'change:displayName', @render

  events:
    'click .js-open-board': 'openBoard'
    'click .js-star-board': 'starBoard'
    'click .js-remove-board': 'removeRecent'
    'moveto': 'moveTo'
    'mouseenter': 'select'
    'mouseleave': 'deselect'

  render: ->
    data = @model.toJSON { prefs: true }
    data.url = Controller.getBoardUrl(@model)

    if @model.getPref('backgroundTile')
      data.backgroundTile = true
      data.backgroundImageThumbnail = @model.getPref('backgroundImage')
    else
      data.backgroundImageThumbnail =
        Util.smallestPreviewBiggerThan(@model.getPref('backgroundImageScaled'), 400, 200)?.url ?
        @model.getPref('backgroundImage')

    # default to blue for old boards that don't have blue set by default, but
    # not if we have a background
    if !data.backgroundImageThumbnail?
      data.backgroundColor = @model.getClientBackgroundColor('blue')

    if @model.getPref('backgroundColor')?
      color = @model.getPref('background')
      data.backgroundColor = @model.getClientBackgroundColor(color)

    data.backgroundBrightness = @model.getPref('backgroundBrightness')

    if @options?.showOrgName
      data.orgname = @model.getOrganization()?.get('displayName')

    data.isLoggedIn = Auth.isLoggedIn()

    data.recent = @options.recent

    @$el.html template(data)

    @renderStarred()
    @renderUnread()

    @

  openBoard: (e) ->
    if !SidebarState.getPinSidebar() && (!e.metaKey && !e.ctrlKey)
      SidebarState.hideSidebar()

    @trackBoardClick()

  starBoard: (e) ->
    Util.stop(e)

    idBoard = @model.id
    boardStarList = Auth.me().boardStarList
    if !boardStarList.getBoardStar(idBoard)?
      boardStarList.starBoard(idBoard)
      @trackStarBoard()
    else
      boardStarList.unstarBoard(idBoard)
      @trackUnstarBoard()

    return

  removeRecent: (e) ->
    Util.stop(e)

    SidebarState.pullBoard(@model.id)

  renderUnread: ->
    unseen = @model.hasUnseenActivity() && !Controller.onBoardView(@model.id)

    @$('.js-unread').toggleClass('any', unseen)
    @$el.toggleClass('has-unread-activity', unseen)

    @

  moveTo: (e, ui) ->
    starredBoards = ui.item.closest('.js-board-list').find('li')
    index = starredBoards.index(ui.item)

    Auth.me().boardStarList.updateStarBoard(@model.id, index)

    return

  renderStarred: ->
    if Auth.me().boardStarList.getBoardStar(@model.id)?
      @$el.addClass('starred')
      @$('.icon-star').addClass('icon-star-active')
    else
      @$el.removeClass('starred')
      @$('.icon-star').removeClass('icon-star-active')
    @

  select: ->
    @$el.addClass('selected')

  deselect: ->
    @$el.removeClass('selected')

  trackBoardClick: ->
    if @model.isMember(Auth.me())
      label = "Board (Member of)"
    else
      label = "Board (Not a Member)"

    track("Search", "Select Item", label)

  trackStarBoard: ->
    track("Search", "Star Board")

  trackUnstarBoard: ->
    track("Search", "Unstar Board")
